export const attachmentsKeys = {
  all: ["attachments"] as const,
  lists: () => [...attachmentsKeys.all, "list"] as const,
  list: (visitId: number) => [...attachmentsKeys.lists(), { visitId }] as const,
};
